import favicon from "../../../../public/icon.svg?raw";
import { isFreshNavigation, shuffle } from "../utils";

export default class Favicon extends HTMLElement {
  /**
   * Defines the element in the document's custom element registry
   * @param {string} [tag] The tag to use in the element definition
   */
  static define(tag = "cwgw-favicon") {
    if (!customElements.get(tag)) {
      customElements.define(tag, this);
    }
  }

  /**
   * Connected callback
   */
  connectedCallback() {
    // Do nothing if the element isn't connected
    if (!this.isConnected) {
      return;
    }

    // On new visits or reloads, replace the favicon
    if (isFreshNavigation()) {
      const colors = [
        "#f2eddb", // beige
        "#1c5572", // blue
        "#b1d0b1", // green
        "#79a7af", // light blue
        "#f7ab25", // orange
        "#fd4068", // pink
        "#c62421", // red
        "#f5e188", // yellow
      ];

      // Get the current favicon link
      const link = document.head.querySelector(
        "link[rel='icon'][type='image/svg+xml']",
      );

      if (link && favicon) {
        // Shuffle colors
        const arr = shuffle(colors).slice(0, 4);

        // Replace colors in the icon
        const re = new RegExp(`(${colors.join("|")})`, "ig");
        let i = 0;
        let svg = favicon.replace(re, () => arr[++i % arr.length]);

        // Create a data URI of the icon
        svg = encodeURIComponent(svg.replace(/\s+/, " "));
        const dataURI = `data:image/svg+xml;charset=UTF-8,${svg}`;

        // Replace the icon source
        link.href = dataURI;
      }
    }
  }
}
